import { FETCH_METHODS, SearchConfig } from "./api.model";
import { cardConfig } from "./common.model";
import {TurnOverReportAreaSearchConfig,SearchKeys} from "./turn-over.model";

export {
  TurnOverTableSchema as HomeDisplayTable,
  TurnoverProps as HomeProps,
  TurnOverTabIds as HomeTabIds,
  TurnoverReportTabConfig as HomeTabConfigIds
} from "./turn-over.model";

const DefaultPostparam = {
    ...(TurnOverReportAreaSearchConfig['body']),
    "jobRole": "Diagnostic Specialist/ Service Technician",
    "area": "",
    "district": "",
    "reportType": "area",
    "dealerCode": "",
    "startDate": "",
    "endDate": ""
}
export const HomeScreenAreaSearchConfig: SearchConfig = {
    ...structuredClone(TurnOverReportAreaSearchConfig),
    path: 'turnOverReport',
    body: structuredClone(DefaultPostparam)
}

export const HomeScreenCertificationSearchConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'turnOverReportCertification',
    body: structuredClone(DefaultPostparam)
}

export const HomeScreenBannerSearchConfig: SearchConfig = {
    method: 'Get',
    path: 'bannersForDashboard'
}

export const TurnOverReportSearchConfig: Record<string, SearchConfig> = {
    [SearchKeys['Area']]: HomeScreenAreaSearchConfig,
    [SearchKeys['Certificate']]: HomeScreenCertificationSearchConfig
}

export const HomePageCardDetails: Array<cardConfig> = [{
    id: 'associateCount',
    class: 'associates-card',
    label: 0,
    isLoading: true,
    value: 'Total Number of Active Lexus Dealer Associates',
    cardStyle: 'labelWithValue'
  }, {
    id: 'certifiedCount',
    class: 'personal-card',
    label: 0,
    isLoading: true,
    value: 'Total Number of Active Personnel in Certified Primary Role',
    cardStyle: 'labelWithValue'
  }]




